module.exports = __webpack_public_path__ + "img/connect-subdomain-light.530e81b6.svg";